import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChangeSystemRatePriorityDialog from '../molecules/ChangeSystemRatePriorityDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false),
  withState('priority', 'setPriority', props => {
    return props.systemRatePriority;
  }),
  withState('oldPriority', 'setOldPriority', props => {
    return props.systemRatePriority;
  })
);

const button = enhance(
  ({
    connectSystemId,
    priority,
    setPriority,
    oldPriority,
    setOldPriority,
    openChange,
    disabled,
    updateOpenChange,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    systemRatePriority
  }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };
    useEffect(() => {
      setPriority(systemRatePriority);
      setOldPriority(systemRatePriority);
    }, [systemRatePriority]);
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          {oldPriority || oldPriority === 0 ? `${oldPriority}%` : ''}
        </Button>
        <ChangeSystemRatePriorityDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          target="Change"
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          connectSystemId={connectSystemId}
          priority={priority}
          setPriority={setPriority}
          oldPriority={oldPriority}
          setOldPriority={setOldPriority}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
